export default "public/rw-widgets.eot";